import React from "react";
import { statusColor, prettyStatus } from "../lib/format";

export default function StatusChip({ status, testId }) {
  return (
    <span
      data-testid={testId || `status-chip-${status}`}
      className={`pill ${statusColor(status)}`}
    >
      <span className="h-1.5 w-1.5 rounded-full bg-current opacity-70" />
      {prettyStatus(status)}
    </span>
  );
}
